import styled from 'styled-components';
import theme from 'styled-theming';
import { prefix } from '../../tools/settings';
var surfaceHeight = theme('size', {
  large: '32px',
  small: '16px'
});
var surfaceBorderRadius = theme('size', {
  large: '16px',
  small: '8px'
});
var trackheight = theme('size', {
  large: '8px',
  small: '4px'
});
var trackMargin = {
  x: theme('size', {
    large: '16px',
    small: '8px'
  }),
  y: theme('size', {
    large: '12px',
    small: '6px'
  })
};
var trackBorderRadius = theme('size', {
  large: '4px',
  small: '2px'
});
var Container = styled.div.withConfig({
  displayName: "GaugeBarstyles__Container",
  componentId: "sc-hmhfoy-0"
})([""]);
var Heading = styled.div.attrs({
  className: "".concat(prefix, "-gaugebar__heading")
}).withConfig({
  displayName: "GaugeBarstyles__Heading",
  componentId: "sc-hmhfoy-1"
})(["padding-bottom:var(--dentsu-spacing-4);"]);
var Title = styled.div.withConfig({
  displayName: "GaugeBarstyles__Title",
  componentId: "sc-hmhfoy-2"
})(["color:", ";font-size:var(--dentsu-font-size-12);font-weight:var(--dentsu-font-weight-regular);line-height:var(--dentsu-leading-tight);"], theme('mode', {
  dark: 'var(--dentsu-color-n100)',
  light: 'var(--dentsu-color-n700)'
}));
var Actual = styled.div.withConfig({
  displayName: "GaugeBarstyles__Actual",
  componentId: "sc-hmhfoy-3"
})(["display:flex;align-items:baseline;"]);
var Value = styled.div.withConfig({
  displayName: "GaugeBarstyles__Value",
  componentId: "sc-hmhfoy-4"
})(["color:", ";font-size:var(--dentsu-font-size-24);font-weight:var(--dentsu-font-weight-light);line-height:var(--dentsu-leading-tight);margin-right:var(--dentsu-spacing-4);"], theme('mode', {
  dark: 'var(--dentsu-color-white)',
  light: 'var(--dentsu-color-n975)'
}));
var Percentage = styled.div.attrs({
  className: "".concat(prefix, "-gaugebar__guage")
}).withConfig({
  displayName: "GaugeBarstyles__Percentage",
  componentId: "sc-hmhfoy-5"
})(["color:", ";font-size:var(--dentsu-font-size-14);font-weight:var(--dentsu-font-weight-regular);line-height:var(--dentsu-leading-tight);"], theme('mode', {
  dark: 'var(--dentsu-color-white)',
  light: 'var(--dentsu-color-n975)'
}));
var Chart = styled.div.attrs({
  className: "".concat(prefix, "-gaugebar__chart")
}).withConfig({
  displayName: "GaugeBarstyles__Chart",
  componentId: "sc-hmhfoy-6"
})(["display:", ";"], theme('layout', {
  inline: 'flex',
  stacked: 'block'
}));
var Surface = styled.div.attrs({
  className: "".concat(prefix, "-gaugebar__surface")
}).withConfig({
  displayName: "GaugeBarstyles__Surface",
  componentId: "sc-hmhfoy-7"
})(["flex:1;background:var(--dentsu-color-n50);height:", ";border-radius:", ";padding:0 ", ";"], surfaceHeight, surfaceBorderRadius, trackMargin.x);
var Inner = styled.div.attrs({
  className: "".concat(prefix, "-gaugebar__inner")
}).withConfig({
  displayName: "GaugeBarstyles__Inner",
  componentId: "sc-hmhfoy-8"
})(["position:relative;height:", ";"], surfaceHeight);
var Track = styled.div.attrs({
  className: "".concat(prefix, "-gaugebar__track")
}).withConfig({
  displayName: "GaugeBarstyles__Track",
  componentId: "sc-hmhfoy-9"
})(["position:absolute;background:var(--dentsu-color-n250);top:", ";right:0;left:0;height:", ";border-radius:", ";"], trackMargin.y, trackheight, trackBorderRadius);
var Bar = styled.div.attrs({
  className: "".concat(prefix, "-gaugebar__bar")
}).withConfig({
  displayName: "GaugeBarstyles__Bar",
  componentId: "sc-hmhfoy-10"
})(["transition:all 0.3s ease-in-out;position:absolute;background:", ";top:", ";left:0;height:", ";border-radius:", ";"], function (props) {
  return props.status === 'negative' ? 'var(--dentsu-color-red)' : props.status === 'warning' ? 'var(--dentsu-color-amber)' : props.status === 'positive' ? 'var(--dentsu-color-g600)' : 'var(--dentsu-color-blue)';
}, trackMargin.y, trackheight, theme('size', {
  large: function large(props) {
    return props.isComplete ? '4px' : '4px 0 0 4px';
  },
  small: function small(props) {
    return props.isComplete ? '2px' : '2px 0 0 2px';
  }
}));
var TickContainer = styled.div.attrs({
  className: "".concat(prefix, "-gaugebar__tickContainer")
}).withConfig({
  displayName: "GaugeBarstyles__TickContainer",
  componentId: "sc-hmhfoy-11"
})(["transition:all 0.3s ease-in-out;display:", ";position:absolute;top:0;width:10px;height:", ";> div{display:block;}> span{width:100%;height:100%;}"], function (props) {
  return props.isComplete ? 'none' : 'block';
}, surfaceHeight);
var TickTooltipTarget = styled.div.attrs({
  className: "".concat(prefix, "-gaugebar__tickTooltipTarget")
}).withConfig({
  displayName: "GaugeBarstyles__TickTooltipTarget",
  componentId: "sc-hmhfoy-12"
})(["position:absolute;top:0;left:0;right:0;bottom:0;"]);
var Pin = styled.div.attrs({
  className: "".concat(prefix, "-gaugebar__pin")
}).withConfig({
  displayName: "GaugeBarstyles__Pin",
  componentId: "sc-hmhfoy-13"
})(["position:absolute;top:0;left:50%;width:1px;height:", ";background:var(--dentsu-color-n1000);"], surfaceHeight);
var Tick = styled.div.attrs({
  className: "".concat(prefix, "-gaugebar__tick")
}).withConfig({
  displayName: "GaugeBarstyles__Tick",
  componentId: "sc-hmhfoy-14"
})(["position:absolute;top:0;left:50%;width:1px;height:", ";background:var(--dentsu-color-n600);&:before,&:after{background:var(--dentsu-color-n250);content:'';position:absolute;left:0;width:1px;height:", ";}&:before{top:", ";}&:after{bottom:", ";}"], surfaceHeight, theme('size', {
  large: 'var(--dentsu-spacing-4)',
  small: 'var(--dentsu-spacing-2)'
}), theme('size', {
  large: 'var(--dentsu-spacing-8)',
  small: 'var(--dentsu-spacing-4)'
}), theme('size', {
  large: 'var(--dentsu-spacing-8)',
  small: 'var(--dentsu-spacing-4)'
}));
var Goal = styled.div.attrs({
  className: "".concat(prefix, "-gaugebar__goal")
}).withConfig({
  displayName: "GaugeBarstyles__Goal",
  componentId: "sc-hmhfoy-15"
})(["position:absolute;top:", ";left:0;height:", ";background:var(--dentsu-color-b200);"], trackMargin.y, trackheight);
var MinMaxLabels = styled.div.attrs({
  className: "".concat(prefix, "-gaugebar__minMaxLabels")
}).withConfig({
  displayName: "GaugeBarstyles__MinMaxLabels",
  componentId: "sc-hmhfoy-16"
})(["display:flex;align-items:center;justify-content:space-between;margin:", ";"], theme('layout', {
  inline: theme('size', {
    large: '0 0 0 var(--dentsu-spacing-8)',
    small: '0 0 0 var(--dentsu-spacing-8)'
  }),
  stacked: theme('size', {
    large: 'var(--dentsu-spacing-4) var(--dentsu-spacing-16)',
    small: 'var(--dentsu-spacing-4) var(--dentsu-spacing-8)'
  })
}));
var Label = styled.div.attrs({
  className: "".concat(prefix, "-gaugebar__label")
}).withConfig({
  displayName: "GaugeBarstyles__Label",
  componentId: "sc-hmhfoy-17"
})(["color:", ";font-size:var(--dentsu-font-size-13);font-weight:var(--dentsu-font-weight-regular);line-height:var(--dentsu-leading-none);"], theme('mode', {
  dark: 'var(--dentsu-color-n100)',
  light: 'var(--dentsu-color-n650)'
}));
var RangeDescription = styled.div.attrs({
  className: "".concat(prefix, "-gaugebar__rangeDescription")
}).withConfig({
  displayName: "GaugeBarstyles__RangeDescription",
  componentId: "sc-hmhfoy-18"
})(["color:", ";font-size:var(--dentsu-font-size-13);font-weight:var(--dentsu-font-weight-regular);font-style:var(--dentsu-font-style-italic);line-height:var(--dentsu-leading-none);margin:", ";"], theme('mode', {
  dark: 'var(--dentsu-color-n100)',
  light: 'var(--dentsu-color-n650)'
}), theme('size', {
  large: 'var(--dentsu-spacing-8) var(--dentsu-spacing-16) 0 var(--dentsu-spacing-16)',
  small: 'var(--dentsu-spacing-4) var(--dentsu-spacing-8) 0 var(--dentsu-spacing-8)'
}));
export var Styled = {
  Actual: Actual,
  Bar: Bar,
  Chart: Chart,
  Container: Container,
  Goal: Goal,
  Heading: Heading,
  Inner: Inner,
  Label: Label,
  MinMaxLabels: MinMaxLabels,
  Percentage: Percentage,
  Pin: Pin,
  RangeDescription: RangeDescription,
  Surface: Surface,
  Tick: Tick,
  TickContainer: TickContainer,
  TickTooltipTarget: TickTooltipTarget,
  Title: Title,
  Track: Track,
  Value: Value
};